package shared.models

data class FooterNavLink(
    val href: String,
    val text: String,
    val isSecondary: Boolean = false
)
